import React, { createContext, useCallback, useContext, useState } from "react";

const ToastContext = createContext(() => {});

const ICONS = { success: "✅", error: "❌" };
const VISIBLE_MS = 3500;
const FADE_MS = 300;

let nextId = 0;

/* The reference's bottom-right toast: shows for 3.5s, then fades and slides out. */
export function ToastProvider({ children }) {
  const [toasts, setToasts] = useState([]);

  const showToast = useCallback((message, type = "success") => {
    const id = ++nextId;
    setToasts((list) => [...list, { id, message, type, leaving: false }]);
    setTimeout(() => {
      setToasts((list) => list.map((t) => (t.id === id ? { ...t, leaving: true } : t)));
    }, VISIBLE_MS);
    setTimeout(() => {
      setToasts((list) => list.filter((t) => t.id !== id));
    }, VISIBLE_MS + FADE_MS);
  }, []);

  return (
    <ToastContext.Provider value={showToast}>
      {children}
      <div className="toast-container no-print">
        {toasts.map((toast) => (
          <div
            key={toast.id}
            className={`toast toast-${toast.type}`}
            style={
              toast.leaving
                ? { opacity: 0, transform: "translateX(30px)", transition: `all ${FADE_MS}ms ease` }
                : undefined
            }
          >
            <span>{ICONS[toast.type] || "ℹ️"}</span> <span>{toast.message}</span>
          </div>
        ))}
      </div>
    </ToastContext.Provider>
  );
}

export const useToast = () => useContext(ToastContext);
